module.exports = __webpack_public_path__ + "assets/img/report-button-3.8f70e4b2.png";